module.exports = __webpack_public_path__ + "img/sLuckyGems_350x350.5e59ed95.jpg";